import { isInDateRange } from '.';

/**
 * @typedef {IsChildDateRangeInput}
 * @property {DateRange} child the date range to check for existence within the parent
 * @property {DateRange} parent a date range that may contain the child date range
 */
interface IsChildDateRangeInput {
    child: DateRange;
    parent: DateRange;
}

/**
 * Returns true if a child DateRange is contained within a parentDateRange.
 * @param {IsChildDateRangeInput} input
 */
export const isChildDateRange = ({
    child,
    parent,
}: IsChildDateRangeInput): boolean => {
    const { start, end } = child;

    return isInDateRange(start, parent) && isInDateRange(end, parent);
};
